import { ETHERSCAN_URL } from "@constants/env";

export const getEtherscanLinkForTxId = (txId: string): string => `${ETHERSCAN_URL}/tx/${txId}`;
